<div class="d-flex flex-column">
    <div class="d-flex align-items-center gap-2">
        <span
            class="primary-area-text d-lg-block title gb-grey-1000 align-items-center"
            gp-test-id="map-header-main-title"
            title="{{ extensionData?.primaryAreaName }}"
        >
            {{ extensionData?.primaryAreaName }}
        </span>
        <span
            title="{{ extensionData?.primaryAreaName }}"
            class="d-lg-none tablet-title gb-grey-1000 align-items-center text-truncate"
        >
            {{ extensionData?.primaryAreaName }}
        </span>
    </div>

    @if (!!extensionData?.primaryAreaSubTitle) {
        <span
            class="d-none d-xl-block gb-grey-1000"
            gp-test-id="map-header-sub-title"
            title="{{ extensionData?.primaryAreaSubTitle }}"
        >{{ extensionData?.primaryAreaSubTitle }}
        </span>
    }
</div>
